import { createAction } from "redux-actions"

// action type
export const SET_SERVER_ERROR_POPUP = "@elefarm/config/SET_SERVER_ERROR_POPUP"

// action function
export const setServerErrorPopup = createAction(SET_SERVER_ERROR_POPUP)
